import MainContent from "../MainContent";
// import MainContent3 from "../MainContent3";
import AsideContent2 from "../AsideContent2";
import PodcastList from "../assets/PodcastList";
import GoToTop from "../GoToTop";
import { Link } from "react-router-dom";


const PodcastsPage = () => {
    return (
        <div className="content">
            <main>
                <MainContent resource={PodcastList}/>
                <h2 className="back"><Link to="/Podcasts" title="Back to Top" className="backLink link">- BACK To TOP -</Link></h2>
            </main>
            <aside>
                <AsideContent2 resource={PodcastList}/>
            </aside>
            <GoToTop />
  	    </div>
    );
}
export default PodcastsPage;